<template>
  <div
    class="fixed md:right-auto md:left-1/2 md:-translate-x-1/2 z-[20] duration-500 transition"
    :class="[
      isActive && isClosable ? 'bg-charcoal-950/50' : (
        isClosable ? 'pointer-events-none !left-[-99999px]' : ''
      ),
      isClosable ? 'top-0 left-0 w-full h-full z-[500] flex items-end p-6' : (
        'bottom-0 left-5 right-5'
      )
    ]"
    :style="{
      paddingBottom: 'max(var(--inset-bottom), 24px)'
    }"
    v-if="!isNative && (currentUser?.experienceLevel ?? 0) > 0"
  >
    <AppDownloadMin
      :is-closable="isClosable"
      class="!bg-white dark:!bg-charcoal-900 dark:text-dark-50 dark:border-dark-800 grow shadow-xl border border-charcoal-100 max-w-xl mx-auto duration-500 transition"
      :class="[
        isActive ? '' : (
          isClosable ? 'opacity-0 translate-y-full' : ''
        )
      ]"
      @close="onClose"
    />
  </div>
</template>

<script lang="ts" setup>
import { getDeviceInfo } from '@/utils/native/useDevice'
import UserStore from '@/store/user'

defineProps<{
  isClosable?: boolean
}>()

const isActive = ref(false)
const isNative = ref(true)

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const onClose = async () => {
  isActive.value = false
  setCookie('app-download-hide', 'true', {
    maxAge: 604800
  })
}

onMounted(async () => {
  const deviceInfo = await getDeviceInfo()
  if (deviceInfo) {
    isNative.value = deviceInfo.platform === 'ios' || deviceInfo.platform === 'android'
  }

  setTimeout(async () => {
    const isAppHidden = await getCookie('app-download-hide') as boolean
    
    if (!isNative.value && !isAppHidden) isActive.value = true
  }, 3000)
})
</script>